import {
  getCheckoutDetailsSuccess, getCheckoutDetailsPending, getCheckoutDetailsFailure,
} from '../actions/checkoutDetails';
import { getCheckoutData } from '../../../../common/facades/eagle/checkout';

export const getCheckoutDetails = cookies => dispatch => {
  dispatch(getCheckoutDetailsPending());
  return getCheckoutData(cookies)
    .then(response => {
      return dispatch(getCheckoutDetailsSuccess(response));
    })
    .catch(error => {
      return dispatch(getCheckoutDetailsFailure(error));
    });
};



// WEBPACK FOOTER //
// ./src/client/js/store/thunks/checkoutDetails.js